import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-confirm-popup',
  templateUrl: './confirm-popup.component.html',
  styleUrls: ['./confirm-popup.component.css']
})
export class ConfirmPopupComponent implements OnInit {
  @ViewChild('contentConfirm') modal: ElementRef;
  deleteId: number;
  deleteType: string;
  @Output() deleteEvent= new EventEmitter();
  @Output() delNote= new EventEmitter();
  modalRef: NgbModalRef;
  constructor(
    private modalService: NgbModal,
  ) { }

  ngOnInit() {
  }
  showModal(id) {
    this.modalRef = this.modalService.open(this.modal, { windowClass: 'confirm-modal' });
    this.deleteId = id;
    this.modalRef.result.then((data) => {
     
    }, (reason) => {
     
    });
  }
  showModalForMap(id, type) {
    this.modalRef = this.modalService.open(this.modal, { windowClass: 'confirm-modal' });
    this.deleteId = id;
    this.deleteType = type;
    this.modalRef.result.then((data) => {
     
    }, (reason) => {
     
    });
  }
  delete(event) {
    let mapDetails = {
      'map_id': this.deleteId,
      'map_type': this.deleteType
    };
    this.deleteEvent.emit(mapDetails);
  }
  closeModal() {
    this.modalRef.close();
  }
  deleteNote(event){
    this.delNote.emit(this.deleteId);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/modal-popup/confirm-popup/confirm-popup.component.ts